// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"403":"f3cad286","629":"e1302b43"}[chunkId] + ".chunk.js";
};